import { Mui, Image } from '@onedesign/ui';
import { ThemeMode } from 'theme/types';
import { Button, Typography } from '@mui/material';

const { Box, styled, FormControl } = Mui;
export const StyledFormContainer = styled(Box)({
  '> form': {
    display: 'flex',
    flexDirection: 'column',
  },
});
export const StyledFormControl = styled(FormControl)({
  textAlign: 'left',
  '&+&': {
    marginTop: '1.5rem',
  },
});
export const StyledLoginMain = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  flexGrow: 1,
  padding: '64px 70px 52px 70px',
  backgroundColor:
    theme.palette.mode === ThemeMode.Dark
      ? theme.palette.grey[800]
      : theme.palette.grey[100],
  borderRadius: '0px 20px 20px 0px',
  '& > h2': {
    color:
      theme.palette.mode === ThemeMode.Dark
        ? theme.palette.grey[100]
        : theme.palette.grey[700],
    margin: '12px 0',
    fontWeight: 700,
  },
  '& > div, & > button': {
    margin: '12px 0',
    width: '100%',
  },
  '@media(max-width: 1024px)': {
    borderRadius: '0 0 20px 20px',
    padding: '24px',
    position: 'initital',
  },
}));

export const StyledSwitchToRegisterAndResetPasswordRequestBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  marginTop: '24px',
  justifyContent: 'center',
  alignItems: 'center',
});

export const StyledSwitchTypography = styled(Typography)({
  '&:hover': {
    fontWeight: 900,
  },
  color: '#637381',
  textAlign: 'right',
  fontWeight: 400,
  lineHeight: '22px',
  fontSize: '14px',
  fontStyle: 'normal',
  fontFamily: 'Noto Sans TC',
  cursor: 'pointer',
});

// Symbolic graph
export const StyledLoginSymbolContainer = styled('div')({
  maxWidth: '263px',
  position: 'absolute',
  right: '-30%',
  bottom: '-25%',
  '@media(max-width: 1024px)': {
    display: 'none',
  },
});
export const StyledLoginSymbol = styled(Image)({});

// export const StyledOperate = styled(Box)(({ theme }) => ({
//   display: 'flex',
//   justifyContent: 'flex-end',
//   color: theme.palette.grey[600],
//   padding: '16px 0',
//   borderTop: `1px solid ${theme.palette.grey[500_24]}`,
//   cursor: 'default',
// }));

// export const StyledCheckBox= styled('div')(({ theme }) => ({
//   display: 'flex',
//   alignItems: 'center',
//   color: theme.palette.mode === 'dark' ? theme.palette.grey[100] : theme.palette.grey[800],
// }))

export const StyledContainerMemberInfo = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  flex: '1 0 0',
  flexGrow: 1,
  padding: '64px 70px 52px 70px',
  backgroundColor:
    theme.palette.mode === ThemeMode.Dark
      ? theme.palette.grey[800]
      : theme.palette.grey[100],
  borderRadius: '0px 20px 20px 0px',
  '& > h2': {
    color:
      theme.palette.mode === ThemeMode.Dark
        ? theme.palette.grey[100]
        : theme.palette.grey[700],
    margin: '12px 0',
    fontWeight: 700,
  },
  '& > div, & > button': {
    margin: '12px 0',
    width: '100%',
  },
  '@media(max-width: 1024px)': {
    borderRadius: '0 0 20px 20px',
    padding: '24px',
    height: 'auto',
    position: 'initial',
  },
}));

export const StyledHeaderConfirm = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  alignSelf: 'stretch',
  fontFamily: 'Noto Sans TC',
  '& > span': {
    color: 'rgba(255, 86, 48, 1)',
  },
});
export const StyledHeaderConfirmTitle = styled('div')({
  fontSize: '24px',
  color: '#454B5C',
  textAlign: 'center',
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: '36px',
});
export const StyledHeaderConfirmTitleHint = styled('div')({
  fontSize: '16px',
  color: '#637381',
  textAlign: 'center',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '24px',
});

export const StyledFormContainerMemberConfirm = styled(Box)({
  '> form': {
    display: 'flex',
    flexDirection: 'column',
  },
  '@media(max-width: 1024px)': {
    height: 'auto',
  },
});
export const StyledFormControlMemberConfirm = styled(FormControl)({
  textAlign: 'left',
  marginTop: '1.5rem',
  flex: 1,
});

export const StyledFormContainerResetPasswordRequest = styled(Box)({
  height: '314px',
  width: '760px',
  '> form': {
    display: 'flex',
    flexDirection: 'column',
  },
  '@media(max-width: 1024px)': {
    height: 'auto',
  },
});

export const StyledBackButton = styled(Button)(({ theme }) => ({
  color: theme.palette.grey[600],
  width: 'auto!important',
  alignSelf: 'start',
  padding: 0,
  fontFamily: 'Noto Sans TC',
  fontSize: '13px',
  fontWeight: 700,
  lineHeight: '22px',
  gap: '0px',
  marginTop: '-30px',
  marginLeft: '-40px',
  '&:hover': {
    background: 'transparent',
  },
  '@media(max-width: 1024px)': {
    position: 'absolute',
    top: '17px',
    left: '29px',
    marginTop: 0,
    marginLeft: 0,
    padding: '4px',
    gap: '8px',
  },
}));
